import {Content} from '../../../_metronic/layout/components/content'
import {KTIcon} from '../../../_metronic/helpers'
import RouteManageForm from './modal/RouteManageForm'
import {RouteManagementProvider, useRouteManagement} from './RouteManagementProvider'
import SelectSenderId from './modal/SelectSenderId'
import RouteSenderRolesList from './RouteSenderRolesList'
import DeleteSenderRouteRole from './modal/DeleteSenderRouteRole'
import UpdateSenderRouteRole from './modal/UpdateSenderRouteRole'
import InputSearchBox from '../../utils/components/form/InputSearchBox'

const RouteManagementWrapper = () => {
  const {searchTerm, setSearchTerm, setSelectRouteSenderRole} = useRouteManagement()

  const onCreate = () => setSelectRouteSenderRole(null)

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div>
          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={onCreate}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Rules Create
          </button>
        </div>
      </div>

      <RouteSenderRolesList />

      <SelectSenderId />
      <RouteManageForm />

      <DeleteSenderRouteRole />
      <UpdateSenderRouteRole />
    </Content>
  )
}

const RouteManagement = () => {
  return (
    <RouteManagementProvider>
      <RouteManagementWrapper />
    </RouteManagementProvider>
  )
}

export default RouteManagement
